module.exports = __webpack_public_path__ + "static/media/driveyello.b4fe3329.png";